import React from "react";

import AdminPagination from "../../_shared/ui/AdminPagination";
import EventCard from "./EventCard";
import EventsEmptyState from "./EventsEmptyState";
import EventsSkeletonList from "./EventsSkeletonList";

export default function EventsList({
  items,
  loading,
  total,
  page,
  totalPages,
  actionId,
  onPageChange,
  onPreview,
  onEdit,
  onToggle,
  onAskDelete,
}) {
  return (
    <section className="mt-5 overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="border-b border-slate-200 px-4 py-4 dark:border-slate-800 sm:px-5">
        <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <h2 className="text-lg font-bold text-slate-950 dark:text-white">
              Liste des événements
            </h2>
            <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
              Retrouvez tous les événements de l’agenda municipal.
            </p>
          </div>

          <p className="text-sm font-bold text-slate-500 dark:text-slate-400">
            Page {page} sur {totalPages}
          </p>
        </div>
      </div>

      {loading ? (
        <EventsSkeletonList />
      ) : !items?.length ? (
        <EventsEmptyState />
      ) : (
        <div className="grid gap-4 p-4 sm:p-5 xl:grid-cols-2">
          {items.map((item) => (
            <EventCard
              key={item.id}
              item={item}
              actionId={actionId}
              onPreview={onPreview}
              onEdit={onEdit}
              onToggle={onToggle}
              onAskDelete={onAskDelete}
            />
          ))}
        </div>
      )}

      <AdminPagination
        page={page}
        totalPages={totalPages}
        total={total}
        loading={loading}
        onPageChange={onPageChange}
      />
    </section>
  );
}